import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/creditCard";
import Spinner from "@/atomic/atoms/Spinner";
import { InputMask } from "@react-input/mask";
import Modal from "@/atomic/atoms/Modal";
import OrgPayment from "@/atomic/organisms/orgPayment";

export default function RechargeCreditCardView({
  isLoading,
  goBack,
  isDisabled,
  error,
  errorChangePaymentMethod,
  goToFinished,
  register,
  handleSubmit,
  errors,
  isVisibleModal,
  toggleModal,
  isVisibleConfirmationModal,
  handleConfirmAutoPayment,
  handleCancelAutoPayment,
  handleAutoPaymentChange,
  customer,
  watch,
  isAutoPaymentEnabled = true,
  attemptCount,
  resetAttemptCount,
  goPaymentOptions
}: PropsView) {
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <form className="z-10 p-2 w-full flex justify-center h-full text-black h-form bg-white" onSubmit={handleSubmit}>
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="pb-[calc(200px)]">
            <h2 className="mt-6 text-black text-xl">Cartão de crédito</h2>
            <div className="flex flex-col justify-center">
              <InputMask
                {...register("number")}
                name="number"
                required
                type="text"
                inputMode="numeric"
                mask="____ ____ ____ ______"
                replacement={{ _: /\d/ }}
                placeholder="Número do cartão"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.number && (
                <span className="text-red-500 text-xs">{errors.number.message as string}</span>
              )}
              <input
                {...register("name")}
                required
                type="text"
                name="name"
                placeholder="Nome no cartão"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.name && (
                <span className="text-red-500 text-xs">{errors.name.message as string}</span>
              )}
              <InputMask
                {...register("expiration")}
                name="expiration"
                required
                type="text"
                inputMode="numeric"
                mask="__/____"
                replacement={{ _: /\d/ }}
                placeholder="Vencimento: MM/AAAA"
                className="mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
              />
              {errors.expiration && (
                <span className="text-red-500 text-xs">{errors.expiration.message as string}</span>
              )}
              <div className="flex flex-row items-center justify-center mt-4 w-full">
                <input 
                  {...register("save")}
                  type="checkbox" 
                  name="save"
                  className="w-6 h-6 accent-black mr-2"
                />
                <p className="w-full text-sm text-black">Salvar este cartão para os próximos pagamentos</p>
              </div>
              {isAutoPaymentEnabled && (
                <div className="flex flex-row items-center justify-center mt-4 w-full">
                  <input 
                    {...register("autoPayment")}
                    type="checkbox" 
                    name="autoPayment"
                    className="w-6 h-6 accent-black mr-2"
                    onChange={handleAutoPaymentChange}
                  />
                  <p className="w-full text-sm text-black">Ativar pagamento direto no cartão cadastrado</p>
                </div>
              )}
            </div>
          </div>
        </article>
        <OrgPayment 
          disabled={isDisabled}
          textLabel="Pagar"
          buttonType="submit"
        />
      </form>
      {error && isVisibleModal && attemptCount === 1 && <Modal
        title="Atenção!"
        message="Não foi possível efetuar a cobrança no seu cartão."
        actionMessage="Tentar novamente"
        action={() => {
          toggleModal();
          handleSubmit();
        }}
        actionSecondMessage="Cancelar"
        actionSecond={toggleModal}
      />}
      {error && isVisibleModal && attemptCount >= 2 && <Modal
        title="Atenção!"
        message="Não foi possível efetuar o seu pagamento."
        actionMessage="Voltar"
        action={() => {
          toggleModal();
          resetAttemptCount();
          goPaymentOptions()
        }}
        actionClose={() => {
          toggleModal();
          resetAttemptCount();
          goPaymentOptions()
        }}
      />}
      {errorChangePaymentMethod && isVisibleModal && <Modal
        title="Atenção!"
        message="Conseguimos quitar suas passagens selecionadas mas não foi possível definir seu cartão como método principal de pagamento. Tente defini-lo mais tarde."
        actionMessage="Ok"
        action={() => {
          toggleModal();
          goToFinished();
        }}
      />}
      {isVisibleConfirmationModal && isAutoPaymentEnabled && <Modal
        title="Atenção!"
        messageElement={
          <div className="text-center">
            <p className="text-sm text-black mb-4">
              Todas as passagens selecionadas e as novas serão debitadas no cartão informado.
            </p>
            <p className="text-sm text-black mb-4">
              Tem certeza que deseja ativar o pagamento direto no cartão:
            </p>
            <p className="text-sm text-black font-mono">
              **** **** **** {watch("number")?.replace(/\D/g, "").slice(-4) || '0000'}
            </p>
          </div>
        }
        actionMessage="Sim"
        action={handleConfirmAutoPayment}
        actionSecondMessage="Não"
        actionSecond={handleCancelAutoPayment}
      />}
      {isLoading && <Spinner />}
    </div>
  );
}
